import { $ } from '../utils';


function VideoLoader() {
    document.addEventListener("DOMContentLoaded", () => {
        window.setTimeout(() => {
            // Getting videos elements
            const elements = document.querySelectorAll('.videoFrameData');
            // Each element
            $(elements, (element) => {
                // If elements not exist
                if (!elements || !elements.length) return;

                // Creating element
                const iframe = document.createElement('iframe');

                // Adding iframe properties
                iframe.setAttribute('src', element.dataset.src);
                iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allowfullscreen', 'true');

                // Adding iframe to element
                element.appendChild(iframe);
            });
        }, 100);
    });
}

export default VideoLoader;  